import React, { useEffect, useMemo, useState } from 'react';
import JobMonitorCard from './JobMonitorCard';
import useParam from '../../context/ParamContext';

const JobMonitorWorkAreas = ({
  workArea,
  onDragStart,
  onDrop,
  isDragging,
  dragOverData,
  autoCompleteData,
  getServiceById,
}) => {
  const { draggingItemId, setDraggingItemId } = isDragging;
  const { dragOverIndex, setDragOverIndex } = dragOverData;

  const scrollId = `scrollableDiv-${workArea.workAreaId}`;
  const scrollSpeed = 100;
  const scrollThreshold = 150;

  const [extendedRows, setExtendedRows] = useState([]);

  useEffect(() => {
    loadInitialData();
  }, [workArea]);

  const loadInitialData = () => {
    setExtendedRows(workArea.rows ?? []);
  };

  const handleDragOver = (event, index) => {
    event.preventDefault();

    const container = event.currentTarget.closest('.custom-scrollbar');
    if (container) {
      const { top, bottom } = container.getBoundingClientRect();
      const mouseY = event.clientY;

      if (mouseY - top < scrollThreshold) {
        container.scrollBy({ top: -scrollSpeed, behavior: 'smooth' });
      } else if (bottom - mouseY < scrollThreshold) {
        container.scrollBy({ top: scrollSpeed, behavior: 'smooth' });
      }
    }

    if (extendedRows[index]?.s_id === draggingItemId) {
      setDragOverIndex({ resourceId: null, index: null });
      return;
    }

    const draggingIndex = extendedRows.findIndex((op) => op.s_id === draggingItemId);
    if (draggingIndex === index || draggingIndex + 1 === index) {
      setDragOverIndex({ resourceId: null, index: null });
    } else {
      setDragOverIndex({ resourceId: workArea.workAreaId, index });
    }
  };

  const handleDropInside = (event) => {
    event.preventDefault();

    const jobItem = JSON.parse(event.dataTransfer.getData('jobItem'));

    const fromIndex = extendedRows.findIndex((op) => op.s_id === jobItem.s_id);
    if (!extendedRows.some((op) => op.s_id === jobItem.s_id)) {
      onDrop(event, workArea);
      setDragOverIndex(null);
      setDraggingItemId(null);
      return;
    }

    const toIndex = dragOverIndex.index;

    if (toIndex === null || fromIndex === toIndex) {
      setDragOverIndex(null);
      setDraggingItemId(null);
      return;
    }

    const reordered = reorderOperations(extendedRows, fromIndex, toIndex);

    /*if (!isSameOrder) {
    const isSameOrder = extendedRows.every(
      (op, idx) => op.s_id === reordered[idx].s_id
    );
      const payload = reordered.map((item, idx) => ({
        id: item.s_id,
        visOrderY: idx + 1,
      }));

      productionService.updateVisOrderYBatch(payload);
    }*/
    setExtendedRows(reordered);
    setDragOverIndex(null);
    setDraggingItemId(null);
  };

  const reorderOperations = (operations, startIndex, endIndex) => {
    const result = Array.from(operations);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result.map((operation, index) => ({
      ...operation,
      visOrderY: index + 1,
    }));
  };

  return (
    <div
      id={scrollId}
      className="flex flex-col max-h-[calc(100vh-140px)] min-h-[calc(100vh-140px)] bg-gray-100 overflow-y-auto custom-scrollbar"
      onDragOver={(event) => event.preventDefault()}
      onDrop={(event) => handleDropInside(event)}
    >
      <div className="bg-white pl-2 text-center font-bold relative py-2 text-labelColor">
        <div className="text-xl">
          {workArea.name}: {workArea.s_total_plannedtime} óra
        </div>
      </div>

      <div className="p-2">
        {extendedRows.map((row, index) => (
          <div key={row.s_id}>
            {dragOverIndex?.resourceId === workArea.workAreaId && dragOverIndex.index === index && (
              <div
                className="mb-3 rounded-md p-4 shadow-md bg-gray-300 border-2 border-gray-500"
                style={{ minHeight: '200px' }}
              ></div>
            )}
            <div onDragOver={(event) => handleDragOver(event, index)}>
              <JobMonitorCard
                data={row}
                onDragStart={onDragStart}
                type="RESOURCECOLUMN"
                autoCompleteData={autoCompleteData}
                getServiceById={getServiceById}
              />
            </div>
          </div>
        ))}

        {dragOverIndex?.resourceId === workArea.workAreaId && dragOverIndex.index === extendedRows.length && (
          <div
            className="mb-3 rounded-md p-4 shadow-md bg-gray-300 border-2 border-gray-500"
            style={{ minHeight: '200px' }}
          ></div>
        )}
      </div>
    </div>
  );
};

export default JobMonitorWorkAreas;
